import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumSiNoTodos, Tc } from '../../../core/_infrastructure/types/common';
import { RegLaboratorioItemResultsViewModel, FilterSearchingRegLaboratorioViewModel, RegLaboratorioItemViewModel } from './laboratorio.types';
import { RegLaboratorioService } from './laboratorio.service';

@Component({
    selector: 'app-laboratorio-list',
    templateUrl: './laboratorio-list.component.html',
})
export class LaboratorioListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    resultLaboratorio: RegLaboratorioItemResultsViewModel;
    listComunidad: Tc[];
    listProvincia: Tc[];
    listMunicipio: Tc[];
    cols: any[];
    visibilitySpinner = false;
    public isCollapsed = false;
    model?: FilterSearchingRegLaboratorioViewModel;

    listSiNoTodos: SelectItem[] = [
        { label: 'Sí', value: EnumSiNoTodos.SI },
        { label: 'NO', value: EnumSiNoTodos.NO },
        { label: 'TODOS', value: EnumSiNoTodos.TODOS },
    ];

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private laboratorioService: RegLaboratorioService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        this.recoverLastSearch();

        this.globalService.getComunidadesAutonomas().subscribe(params => {
            this.listComunidad = params;
        });

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'RazonSocial', header: 'Razón Social' },
            { field: 'IdComunidadAutonomaDescripcion', header: 'Comunidad Autónoma' },
            { field: 'IdProvinciaDescripcion', header: 'Provincia' },
            { field: 'IdMunicipioDescripcion', header: 'Municipio' },
            { field: 'Activo', header: 'Activo' },
            { field: 'Direccion', header: 'Dirección' },
            { field: 'CodigoPostal', header: 'Código Postal' },
            { field: 'NombrePersonaContacto', header: 'Nombre Persona Contacto' },
            { field: 'ApellidosPersonaContacto', header: 'Apellidos Persona Contacto' },
            { field: 'EmailPersonaContacto', header: 'Email Persona Contacto' },
            { field: 'TelefonoPersonaContacto', header: 'Teléfono Persona Contacto' },
            { field: 'Observaciones', header: 'Observaciones' },
        ];

        this.form = this.fb.group({
            RazonSocial: '',
            Direccion: '',
            CodigoPostal: '',
            IdComunidadAutonoma: null,
            IdProvincia: null,
            IdMunicipio: null,
            NombrePersonaContacto: '',
            ApellidosPersonaContacto: '',
            EmailPersonaContacto: '',
            TelefonoPersonaContacto: '',
            Activo: EnumSiNoTodos.TODOS,
        });

        this.loadBack();
    }

    loadBack() {
        if (
            this.laboratorioService.currentFilter.RazonSocial != '' ||
            this.laboratorioService.currentFilter.Direccion != '' ||
            this.laboratorioService.currentFilter.CodigoPostal != '' ||
            this.laboratorioService.currentFilter.IdComunidadAutonoma != null ||
            this.laboratorioService.currentFilter.IdProvincia != null ||
            this.laboratorioService.currentFilter.IdMunicipio != null ||
            this.laboratorioService.currentFilter.NombrePersonaContacto != '' ||
            this.laboratorioService.currentFilter.ApellidosPersonaContacto != '' ||
            this.laboratorioService.currentFilter.EmailPersonaContacto != '' ||
            this.laboratorioService.currentFilter.TelefonoPersonaContacto != '' ||
            this.laboratorioService.currentFilter.Activo != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                RazonSocial: this.laboratorioService.currentFilter.RazonSocial,
                Direccion: this.laboratorioService.currentFilter.Direccion,
                CodigoPostal: this.laboratorioService.currentFilter.CodigoPostal,
                IdComunidadAutonoma: this.laboratorioService.currentFilter.IdComunidadAutonoma,
                IdProvincia: this.laboratorioService.currentFilter.IdProvincia,
                IdMunicipio: this.laboratorioService.currentFilter.IdMunicipio,
                NombrePersonaContacto: this.laboratorioService.currentFilter.NombrePersonaContacto,
                ApellidosPersonaContacto: this.laboratorioService.currentFilter.ApellidosPersonaContacto,
                EmailPersonaContacto: this.laboratorioService.currentFilter.EmailPersonaContacto,
                TelefonoPersonaContacto: this.laboratorioService.currentFilter.TelefonoPersonaContacto,
                Activo: this.laboratorioService.currentFilter.Activo,
            });

            this.onSearchButton();
        }
    }

    onSelectComunidad() {
        const idCA = this.form.value.IdComunidadAutonoma;

        this.globalService.getProvinciasByComunidad(idCA).subscribe(params => {
            this.listProvincia = params;
        });

        this.form.patchValue({
            IdProvincia: null,
            IdMunicipio: null,
        });
    }

    onSelectProvincia() {
        const idProvincia = this.form.value.IdProvincia;

        this.globalService.getMunicipios(idProvincia).subscribe(params => {
            this.listMunicipio = params;
        });

        this.form.patchValue({
            IdMunicipio: null,
        });
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.laboratorioService.currentFilter.RazonSocial = this.form.value.RazonSocial;
        this.laboratorioService.currentFilter.Direccion = this.form.value.Direccion;
        this.laboratorioService.currentFilter.CodigoPostal = this.form.value.CodigoPostal;
        this.laboratorioService.currentFilter.IdComunidadAutonoma = this.form.value.IdComunidadAutonoma;
        this.laboratorioService.currentFilter.IdProvincia = this.form.value.IdProvincia;
        this.laboratorioService.currentFilter.IdMunicipio = this.form.value.IdMunicipio;
        this.laboratorioService.currentFilter.NombrePersonaContacto = this.form.value.NombrePersonaContacto;
        this.laboratorioService.currentFilter.ApellidosPersonaContacto = this.form.value.ApellidosPersonaContacto;
        this.laboratorioService.currentFilter.EmailPersonaContacto = this.form.value.EmailPersonaContacto;
        this.laboratorioService.currentFilter.TelefonoPersonaContacto = this.form.value.TelefonoPersonaContacto;
        this.laboratorioService.currentFilter.Activo = this.form.value.Activo;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = 0, orderBy = 'RazonSocial') {
        this.loading = true;

        this.model = this.CreateModel();

        this.model.PageNumber = pageNumber;
        this.model.Asc = asc;
        if (orderBy === 'Nombre') {
            this.model.OrderBy = 'RazonSocial';
        } else {
            this.model.OrderBy = orderBy;
        }

        this.laboratorioService.postGetPagedByFilter(this.model).subscribe(res => {
            this.resultLaboratorio = res;

            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            RazonSocial: '',
            Direccion: '',
            CodigoPostal: '',
            IdComunidadAutonoma: null,
            IdProvincia: null,
            IdMunicipio: null,
            NombrePersonaContacto: '',
            ApellidosPersonaContacto: '',
            EmailPersonaContacto: '',
            TelefonoPersonaContacto: '',
            Activo: EnumSiNoTodos.TODOS,
        });

        this.listProvincia = [];
        this.listMunicipio = [];

        this.searchingButton = false;
        this.isCollapsed = false;

        this.resultLaboratorio = new RegLaboratorioItemResultsViewModel();
    }

    CreateModel() {
        this.model = new FilterSearchingRegLaboratorioViewModel();

        Object.assign(this.model, this.form.value);

        return this.model;
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/registros/laboratorios/create']);
    }

    onEdit(item: RegLaboratorioItemViewModel) {
        this.router.navigate(['/mantenimiento/registros/laboratorios/edit', item.Id]);
    }

    onDelete(item: RegLaboratorioItemViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.laboratorioService.deleteLaboratorio(item.Id).subscribe({
                    next: res => {
                        let mensaje = 'El Laboratorio ha sido eliminado correctamente.';
                        if (res === true) {
                            mensaje = 'El Laboratorio está siendo utilizado en alguna Solicitud con envío de muestras, se ha marcado como NO Activo.';
                        }
                        this.addSuccessMessage(mensaje);
                        this.onSearchButton();
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.laboratorioService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }

    exportIsAvailable(): boolean {
        return this.resultLaboratorio?.ResultList ? this.resultLaboratorio?.ResultList?.length > 0 : false;
    }

    private recoverLastSearch() {
        this.model = this.laboratorioService.getLastSearch();

        if (this.model?.IdComunidadAutonoma) {
            this.globalService.getProvinciasByComunidad(this.model?.IdComunidadAutonoma).subscribe(params => {
                this.listProvincia = params;
            });
            if (this.model?.IdProvincia) {
                this.globalService.getMunicipios(this.model?.IdProvincia).subscribe(params => {
                    this.listMunicipio = params;
                });
            }
        }
    }

    get disableSearchBtn(): boolean {
        return this.isCollapsed || !this.listComunidad;
    }
}
